import axios from './AxiosInstance'

export default {
  fetch: () => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/healthcheck',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        withCredentials: true
      }).then(res => {
        console.log(res)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
}